<dashboardnav>
  
    <cradua-ownershiptype
    [ownershiptypes]="ownershiptypes$ | async"
    (ownershiptype)="onSubmitOwnershipType($event)"
    (deleteOwnershipTypeEvent)="onDeleteOwnershipType($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-ownershiptype>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  